import { TextButton } from 'components/v2/buttons';
import React, { useState } from 'react';
import TextWithAnimatedEllipsis from 'components/v2/file-upload/TextWithAnimatedEllipsis';
import { HelpBox } from 'components/v2/help-boxes';
import { FieldPanelFullWidth, FieldPanelHeader } from 'styles/v2/Styles.styled';
import downloadLcdEpdByAdmin from 'util/downloadlcdEpdByAdmin';
import FontIcon from 'components/icons/FontIcon';

interface Props {
  epdVersionId: string;
}

const CompilerAdminDownloadIlcdEpd: React.FC<Props> = ({ epdVersionId }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = async () => {
    if (isLoading) {
      return null;
    }

    setIsLoading(true);
    await downloadLcdEpdByAdmin(epdVersionId);
    setIsLoading(false);
  };

  return (
    <FieldPanelFullWidth>
      <FieldPanelHeader>ILCD+EPD</FieldPanelHeader>
      <div>
        <HelpBox>
          You can download ILCD+EPD bundle and check it in the validation tool before approving the EPD publication.
        </HelpBox>
        <TextButton
          label="Download ILCD+EPD"
          icon={<FontIcon icon="download" style={{ fontSize: 16, lineHeight: 1 }} />}
          text
          onClick={handleDownload}
        />
        {isLoading && <TextWithAnimatedEllipsis>Generating bundle</TextWithAnimatedEllipsis>}
      </div>
    </FieldPanelFullWidth>
  );
};

export default CompilerAdminDownloadIlcdEpd;
